import { render, staticRenderFns } from "./AccordionColumn.vue?vue&type=template&id=49bd4e81&scoped=true&"
import script from "./AccordionColumn.vue?vue&type=script&lang=js&"
export * from "./AccordionColumn.vue?vue&type=script&lang=js&"
import style0 from "./AccordionColumn.vue?vue&type=style&index=0&id=49bd4e81&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bd4e81",
  null
  
)

export default component.exports